export enum CLICK_PRODUCT_VIEW_SOURCE {
	PDP_RECOMMENDED_SIMILAR = 'pdp_similar_products',
	PDP_RECOMMENDED_OUTFIT = 'pdp_complete_look',
	QUICK_CART_RECOMMENDED = 'quick_cart_recomendados',
	PERSONALIZATION_OUTFIT = 'cupon_para_ti_outfit',
	PERSONALIZATION_COMPLEMENTS = 'cupon_para_ti_complementos',
	PERSONALIZATION_RECOMMENDED = 'cupon_para_ti_recomendados',
	PERSONALIZATION_SAME_BRAND = 'cupon_para_ti_marca',
	PERSONALIZATION_FAMILY = 'cupon_para_ti_familia',
}

export const CLICK_SOURCE_LIST_NAME: Record<CLICK_PRODUCT_VIEW_SOURCE, string> = {
	[CLICK_PRODUCT_VIEW_SOURCE.PDP_RECOMMENDED_SIMILAR]: 'PDP - Productos similares',
	[CLICK_PRODUCT_VIEW_SOURCE.PDP_RECOMMENDED_OUTFIT]: 'PDP - Completa tu look',
	[CLICK_PRODUCT_VIEW_SOURCE.QUICK_CART_RECOMMENDED]: 'Minicart - Recomendados',
	[CLICK_PRODUCT_VIEW_SOURCE.PERSONALIZATION_OUTFIT]: 'Cupón para ti - Outfit',
	[CLICK_PRODUCT_VIEW_SOURCE.PERSONALIZATION_COMPLEMENTS]: 'Cupón para ti - Complementos',
	[CLICK_PRODUCT_VIEW_SOURCE.PERSONALIZATION_RECOMMENDED]: 'Cupón para ti - Recomendados',
	[CLICK_PRODUCT_VIEW_SOURCE.PERSONALIZATION_SAME_BRAND]: 'Cupón para ti - Misma marca',
	[CLICK_PRODUCT_VIEW_SOURCE.PERSONALIZATION_FAMILY]: 'Cupón para ti - Familia',
};
